module.exports = __webpack_public_path__ + "media/fonts/UHC_Sans/UHCSans-Medium-58bb7b7024040a842674da92f15bf620.eot";